import CopyrightIcon from "@mui/icons-material/Copyright";
import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled, { ThemeProvider } from "styled-components";
import Menu from "./components/Menu";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import Search from "./pages/Search";
import Signin from "./pages/Signin";
import Video from "./pages/Video";
import { darkTheme, lightTheme } from "./utils/Theme";

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
const Container1 = styled.div`
  display: flex;
  width: 100%;
`;

const Main = styled.div`
  flex: 7;
  background-color: ${({ theme }) => theme.bg};
  color: ${({ theme }) => theme.textSoft};

  @media only screen and (max-width: 1024px) {
    flex: 8;
    justify-content: center;
  }
`;

const Wrapper = styled.div`
  padding: 96px;
  @media only screen and (max-width: 1024px) {
    padding: 60px 20px;
  }
`;
const Footer = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.text};
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: ${({ theme }) => theme.bg};
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    font-size: 14px;
  }
`;
const Span = styled.span`
  justify-content: center;
  align-items: center;
  display: flex;
`;

const Link = styled.a`
  color: crimson;
  font-weight: 800;
  font-size: 16px;
  @media only screen and (max-width: 1024px) {
    font-weight: 500;
    font-size: 14px;
  }
`;

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [smDisplay, setSmDisplay] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 1024) {
      setSmDisplay(false);
    } else {
      setSmDisplay(true);
    }
  }, []);

  useEffect(() => {
    toast.success(
      `Welcome in MoudTube 💖😉!! 
      You can enable the dark mode 🌛 it's the 4th option of the menu`,
      {
        position: "top-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      }
    );
  }, []);

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Container>
        <BrowserRouter>
          <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
          <Container1>
            {!smDisplay && (
              <Menu darkMode={darkMode} setDarkMode={setDarkMode} />
            )}
            <Main>
              <Wrapper>
                <ToastContainer
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="dark"
                />

                <Routes>
                  <Route path="/">
                    <Route index element={<Home type="random" />} />
                    <Route path="/trend" element={<Home type="trend" />} />
                    <Route path="/sub" element={<Home type="sub" />} />
                    <Route path="/search" element={<Search />} />
                    <Route path="/profile/:id" element={<Profile />} />
                    <Route path="signin" element={<Signin />} />
                    <Route path="video">
                      <Route path=":id" element={<Video />} />
                    </Route>
                  </Route>
                </Routes>
              </Wrapper>
            </Main>
          </Container1>
        </BrowserRouter>
        <Footer>
          Created with love by &nbsp;
          <Link href="https://www.linkedin.com/in/mahmoud-ayed-111329207">
            &#9825; Mahmoud &#9825;
          </Link>
          <Span>
            &nbsp; <CopyrightIcon />
            2022 All rights reserved.
          </Span>
        </Footer>
      </Container>
    </ThemeProvider>
  );
}

export default App;
